var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPjm = function SvgPjm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 9,
    fill: "none",
    viewBox: "0 0 24 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--c-dark-blue2)",
    d: "M12.302 2.347c1.319 0 2.382 1.194 2.382 2.659 0 1.468-1.063 2.662-2.382 2.662h-.623v-5.32zm.242 7.647c2.469 0 4.477-2.237 4.477-4.988 0-2.763-1.988-4.997-4.456-4.997H9.8V10h2.745M8.873 10H6.914V8.679H3.632L2.877 10H0L6.426.008h2.447zm-4.01-3.403h2.063V3.019zM22.262 0h-1.101c1.243 1.379 1.96 3.268 1.96 5.231 0 1.743-.561 3.408-1.555 4.73h1.0559999999999998C23.505 8.605 24 6.943 24 5.23c0-1.928-.63-3.783-1.738-5.232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--c-dark-blue2)",
    d: "M20.01 0H18.91c1.243 1.379 1.96 3.268 1.96 5.231 0 1.743-.561 3.408-1.555 4.73h1.049c.89-1.356 1.385-3.018 1.385-4.73 0-1.928-.63-3.783-1.738-5.232"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--c-dark-blue2)",
    d: "M17.751 0h-1.094C17.9 1.378 18.61 3.267 18.61 5.23c0 1.743-.561 3.408-1.548 4.73h1.049c.89-1.356 1.378-3.018 1.378-4.73 0-1.928-.623-3.783-1.738-5.232"
  })));
};
export default SvgPjm;